module.exports = __webpack_public_path__ + "static/media/logo copy 2.8b1b4321.png";